export default __webpack_public_path__ + "assets/images/eddb031e39982c0cdf6fc9c65e0eb689.jpg";